'use client';

import Error from '@components/ErrorPage';
import { useEffect } from 'react';

export default function ErrorPage({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Error in /[organization_id] page:', error);
  }, [error]);

  return <Error reset={reset} />;
}
